/**
 * Shared inline-style tokens for CG Boost views.
 * Aligned to the Culture Genius design system tokens (Midnight, Saffron, Plum).
 */

import React from 'react';
import type { StatusVariant } from '../ui';

export type FlagVariant = 'top' | 'warn' | 'info' | 'muted';

export const flagToStatus: Record<FlagVariant, StatusVariant> = {
  top:   'live',
  warn:  'pending',
  info:  'approved',
  muted: 'paused',
};

export const cardStyle: React.CSSProperties = {
  backgroundColor: 'var(--bg-surface-1)',
  border: '1px solid var(--border-1)',
  borderRadius: 'var(--radius-lg)',
  padding: '18px 20px',
  boxShadow: 'var(--shadow-xs)',
};

export const sectionTitle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--fg-4)',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  margin: '0 0 12px 0',
};

export const metricGrid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: 14,
};

export const tinyTable: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 13,
};

export const tinyTh: React.CSSProperties = {
  textAlign: 'left',
  padding: '10px 12px',
  borderBottom: '1px solid var(--border-1)',
  color: 'var(--fg-4)',
  fontSize: 10.5,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  fontWeight: 700,
};

export const tinyTd: React.CSSProperties = {
  padding: '10px 12px',
  borderBottom: '1px solid var(--border-subtle)',
  color: 'var(--fg-1)',
  fontVariantNumeric: 'tabular-nums',
};

export const eyebrowLabel: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--fg-4)',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
};

export const mutedText: React.CSSProperties = {
  color: 'var(--fg-3)',
  fontSize: 13,
};

export const errorText: React.CSSProperties = {
  color: 'var(--danger)',
  fontSize: 13,
};

export const placeholderBadge: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  borderRadius: 'var(--radius-pill)',
  backgroundColor: 'var(--accent-2-soft)',
  color: 'var(--accent-2-soft-fg)',
  border: '1px solid transparent',
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};
